// Framework and third-party non-ui
import React, { useContext, useState } from "react";
import { Link as LinkRouter } from "react-router-dom";

// App components
import User from "components/User";
import { UserContext } from "contexts/UserContext";
import { MapContext } from "contexts/MapContext";
import Breakpoint from "App/Breakpoint";
import { makeStyles } from "@material-ui/core/styles";
import Link from "@material-ui/core/Link";
import SubmitFeedback from "components/SubmitFeedback";

// JSON & Styles
import {
  StyledLogo,
  StyledMainLogo,
  StyledHeader,
  StyledCalciteH1,
  UserWrapper,
} from "./Header-styled";

// Third-party components (buttons, icons, etc.)
import LayerBasemapIcon from "calcite-ui-icons-react/LayerBasemapIcon";

const Header = () => {
  const { ready, userInfo } = useContext(UserContext);
  const {
    mapView,
    setSidebarSelection,
    setAdvancedOptions,
    clickedTab,
    setClickedTab,
  } = useContext(MapContext);

  const useStyles = makeStyles({
    nonClicked: {
      color: "#ffffff",
      marginLeft: "24px",
      alignSelf: "center",
      textDecoration: "none",
      fontWeight: "400",
    },
    clicked: {
      color: "#ffffff",
      marginLeft: "24px",
      alignSelf: "center",
      fontWeight: "700",
    },
    userFlex: {
      display: "flex",
      justifyContent: "flex-end",
      flexGrow: "1",
      color: "#ffffff",
    },
  });

  const classes = useStyles();

  const handleExplorerClick = (event) => {
    event.preventDefault();
    setClickedTab("Explorer");
    setSidebarSelection(null);
  };

  const handleFavoritesClick = (event) => {
    event.preventDefault();
    setClickedTab("Favorites");
    setSidebarSelection(["Favorites"]);
  };

  const handleProfileClick = (event) => {
    event.preventDefault();
    setClickedTab("Profile");
    setSidebarSelection(["Profile"]);
  };

  const removeGraphics = () => {
    if (mapView) {
      mapView.graphics.removeAll();
    }
    setSidebarSelection(null);
    setAdvancedOptions({});
    setClickedTab("Explorer");
  };

  return (
    <StyledHeader data-testid="Header">
      <div style={{ display: "flex", flexGrow: "1" }}>
        <StyledLogo
          to="/home"
          onClick={removeGraphics}
          aria-label="Detour Homepage Link"
        />
        <Link
          href="#"
          className={
            clickedTab === "Explorer" ? classes.clicked : classes.nonClicked
          }
          onClick={handleExplorerClick}
          aria-label="Explorer"
        >
          Explorer
        </Link>
        {userInfo ? (
          <Link
            href="#"
            className={
              clickedTab === "Favorites" ? classes.clicked : classes.nonClicked
            }
            onClick={handleFavoritesClick}
            aria-label="Favorites"
          >
            Favorites
          </Link>
        ) : null}
        {userInfo ? (
          <Link
            href="#"
            className={
              clickedTab === "Profile" ? classes.clicked : classes.nonClicked
            }
            onClick={handleProfileClick}
            aria-label="Profile"
          >
            Profile
          </Link>
        ) : null}
      </div>
      <StyledCalciteH1
        style={{
          fontFamily: "Montserrat",
          fontWeight: "500",
          flexGrow: "1",
          color: "#ffffff",
          fontSize: "20px",
          lineHeight: "24px",
          letterSpacing: "0.15px",
        }}
      >
        <Breakpoint name="desktop">
          <LinkRouter
            to="/home"
            onClick={removeGraphics}
            aria-label="Detour Homepage Link"
          >
            <StyledMainLogo aria-label="Detour Homepage Link" />
          </LinkRouter>
        </Breakpoint>
      </StyledCalciteH1>
      <UserWrapper className={classes.userFlex}>
        <Breakpoint name="phone">
          <LayerBasemapIcon size={32} />
        </Breakpoint>
        <SubmitFeedback />
        {ready ? <User userInfo={userInfo} /> : null}
      </UserWrapper>
    </StyledHeader>
  );
};

export default Header;
